import { useCallback, useState } from 'react';
import { Modal, RenderIf } from 'react-rainbow-components';
import Button from 'components/Button';
import ModalTitle from 'components/ModalTitle';
import { ModalContent, ModalFooter, StyledFileSelector } from './styled';

interface Props {
    isOpen?: boolean;
    acceptedFormats?: string;
    onRequestClose?: () => void;
    onAttach?: (filesList: FileList | null) => void;
}

const AttachFilesModal = ({
    isOpen = false,
    acceptedFormats,
    onRequestClose = () => {},
    onAttach = () => {},
}: Props) => {
    const [files, setFiles] = useState<FileList | null>(null);

    const handleClose = useCallback(() => {
        setFiles(null);
        onRequestClose();
    }, [onRequestClose]);

    const handleAttach = useCallback(() => {
        onAttach(files);
        setFiles(null);
        onRequestClose();
    }, [files, onAttach, onRequestClose]);

    const footer = (
        <ModalFooter>
            <Button
                variant="border"
                borderRadius="semi-square"
                onClick={handleClose}
            >
                Cancel
            </Button>
            <Button
                variant="brand"
                borderRadius="semi-square"
                onClick={handleAttach}
                disabled={!files || files.length === 0}
            >
                Attach
            </Button>
        </ModalFooter>
    );

    return (
        <Modal
            title={<ModalTitle>Attach Files</ModalTitle>}
            isOpen={isOpen}
            footer={footer}
            onRequestClose={handleClose}
            borderRadius="semi-square"
        >
            <ModalContent>
                <RenderIf isTrue={isOpen}>
                    <StyledFileSelector
                        variant="multiline"
                        multiple
                        accept={acceptedFormats}
                        placeholder="Drag & Drop or Click to Browse"
                        onChange={setFiles}
                    />
                </RenderIf>
            </ModalContent>
        </Modal>
    );
};

export default AttachFilesModal;
